import FileUploadSection from "../../../FileUploadSection/FileUploadSection";
import AssociationSection from "../AssociationSection/AssociationSection";
import OriginSection from "../OriginSection/OriginSection";
import AnnotationSection from "../AnnotationSection/AnnotationSection";
import CustomReactSelect from "../../../CustomReactSelect/CustomReactSelect";
import "./MatchSection.scss";

const MatchSection = ({
  headers,
  comuni,
  groups,
  group,
  tipoJson,
  origins = [],
  annotations = [],
  cassettaId,
  handleTipoChange,
  handleKeyChange,
  handleSelectChange,
  handleInputChange,
  handleAssocChange,
  handleCSVXlsUpload,
  handleAddOrigin,
  handleAddAnnotation,
  handleAnnotationChange,
  handleDeleteOrigin,
  handleDeleteAnnotation,
  handleComuneCassettaIdChange,
  handleGroupChange,
}) => {
  return (
    <div className="modal-upload-section-container">
      <FileUploadSection
        handleUpload={handleCSVXlsUpload}
        acceptType={".xls,.csv,.xlsx"}
      />
      {headers.length ? (
        <div className="modal-upload-section-content">
          <div className="comune-cassetta-section">
            <CustomReactSelect
              options={groups}
              displayAttr={"name"}
              value={group}
              label="Gruppo di lavoro"
              placeholder="Seleziona gruppo di lavoro"
              onChange={handleGroupChange}
            />
          </div>
          <div className="comune-cassetta-section">
            <CustomReactSelect
              options={comuni}
              displayAttr={"nome"}
              value={cassettaId}
              label="Comune o sito di giacenza"
              placeholder="Seleziona comune o parco di giacenza"
              onChange={handleComuneCassettaIdChange}
            />
          </div>
          <div className="modal-upload-match-section">
            <AssociationSection
              headers={headers}
              handleChange={handleAssocChange}
            />
          </div>
          <div className="origin-add-btn-wrapper">
            <button onClick={handleAddAnnotation}>Aggiungi annotazione</button>
          </div>
          <div className="annotation-section-container">
            {annotations?.length
              ? annotations?.map((annotation, index) => (
                  <AnnotationSection
                    key={index}
                    headers={headers}
                    annotation={annotation}
                    handleAnnotationChange={handleAnnotationChange}
                    handleDeleteAnnotation={handleDeleteAnnotation}
                  />
                ))
              : null}
          </div>
          <div className="origin-add-btn-wrapper">
            <button onClick={handleAddOrigin}>Aggiungi origine</button>
          </div>
          {origins?.length
            ? origins?.map((origin, index) => (
                <OriginSection
                  key={index}
                  originNo={index}
                  origin={origin}
                  tipoJson={tipoJson}
                  headers={headers}
                  handleTipoChange={handleTipoChange}
                  handleSelectChange={handleSelectChange}
                  handleInputChange={handleInputChange}
                  handleKeyChange={handleKeyChange}
                  handleDeleteOrigin={handleDeleteOrigin}
                />
              ))
            : null}
        </div>
      ) : null}
    </div>
  );
};

export default MatchSection;
